import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/services/auth/auth.service';

export const authInverseGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = auth.getToken();

    if (token && !auth.isTokenExpired()) {
    return router.parseUrl('/area-cidadao');
  }

  if (token) {
    auth.logout();
  }

  return true;
};
